import { Component, OnInit } from '@angular/core';
import { BaseIcon } from '../base-icon';

@Component({
	selector: 'app-icon-agency',
	templateUrl: './icon-agency.component.html',
	styleUrls: ['./icon-agency.component.scss'],
})
export class IconAgencyComponent extends BaseIcon implements OnInit {
	constructor() {
        super();
    }

	ngOnInit() {}
}
